<div class="container">
    <div class="card">
        <img src="img/ACCESS_DENIED.png" alt="Acceso denegado" class="image" />
        <h1>ACCESO NO AUTORIZADO</h1>
        <p>
            Actualmente no estás autorizado para acceder a esta aplicación.<br>
            Ponte en contacto con el administrador para más detalles.<br>
            Email: <b>desarrollo1&#64;acincwk.org</b>
        </p>
        <button class="primary-button" (click)="logout()">Salir</button>
    </div>
</div>
